import { render } from "./NoProposal.vue?vue&type=template&id=1ed1e7f8&scoped=true"
import script from "./NoProposal.vue?vue&type=script&lang=js"
export * from "./NoProposal.vue?vue&type=script&lang=js"

import "./NoProposal.vue?vue&type=style&index=0&id=1ed1e7f8&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed1e7f8"]])

export default __exports__